import axios from './axiosConfig';

const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.test.raborisk.ai" 
    : "http://localhost:3000";

// Action Creators

export const setActiveCompliance = (compliance_id) => {
    ////////console.log("set active compliance id:", compliance_id);
    return { type: "SET_ACTIVE_COMPLIANCE", compliance_id };
};

export const resetComplianceDashboard = () => {
    return { type: "RESET_COMPLIANCE_DASHBOARD" };
};

export const openComplianceDashboard = (compliance_id) => {
    return { type: "OPEN_COMPLIANCE_DASHBOARD", compliance_id };
};

export const getComplianceStandards = () => {
    return (dispatch) => {
        axios.get(`${API_URL}/api/compliance/get_compliance_standards`)
            .then(({ data }) => {
                ////////console.log("get compliance data:", data);
                dispatch({ type: "COMPLIANCE_STANDARDS", complianceStandards: data });
            });
    };
};

export const getComplianceStandardsByCompany = () => {
    return (dispatch) => {
        axios
            .get(`${API_URL}/api/compliance/get_compliance_standards_company`)
            .then(({ data }) => {
                dispatch({
                    type: "COMPLIANCE_STANDARDS",
                    complianceStandards: data,
                });
            });
    };
};


export const addProcedureToCompliance = (compliance_id, data) => {
    return (dispatch) => {
        axios.post(`${API_URL}/api/compliance/add_procedure`, { compliance_id, details: data })
            .then(({ data }) => {
                dispatch({ type: "PROCEDURES", complianceStandards: data });
            });
    };
};

export const updateComplianceStandard = (compliance_id, data) => {
    return (dispatch) => {
        ////////console.log("check status:", data);
        axios.post(`${API_URL}/api/compliance/update_standard`, { compliance_id, data })
            .then(({ data }) => {
                ////////console.log("update returned data: ", data);
                //dispatch({ type: "COMPLIANCE_STANDARDS", complianceStandards: data });
                 return data;
            });
    };
};

export const deleteComplianceStandard = (compliance_id) => {
    return (dispatch) => {
        ////console.log("check status:", compliance_id);
        axios.post(`${API_URL}/api/compliance/delete_standard`, { compliance_id })
            .then(({ data }) => {
                ////console.log("update returned data: ", data);
                dispatch({ type: "COMPLIANCE_STANDARD_DELETE", id: data });
            });
    };
};

export const addAttachmentToProcedure = (compliance_id, procedure_id, file) => {
    return (dispatch) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('compliance_id', compliance_id);
        formData.append('procedure_id', procedure_id);

        axios.post(`${API_URL}/api/compliance/add_attachment`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(({ data }) => {
                dispatch({ type: "PROCEDURES", complianceStandards: data });
            })
            .catch(error => {
                console.error('Error uploading file:', error);
            });
    };
};

export const editComplianceProcedure = (compliance_id, procedure_id, procedure) => {
    return (dispatch) => {
        axios.post(`${API_URL}/api/compliance/edit_procedure`, { compliance_id, procedure_id, procedure })
            .then(({ data }) => {
                dispatch({ type: "PROCEDURES", complianceStandards: data });
            });
    };
};

export const resetNewlyCreatedComplianceId = () => {
    return { type: "RESET_NEWLYCREATED_COMPLIANCE_ID" };
};

export const createComplianceStandard = () => {
    return (dispatch, getState) => {
        axios.post(`${API_URL}/api/compliance/create_standard`)
            .then(({ data }) => {
                ////////console.log("API Response:", data); // Debugging output

                const { complianceStandards } = getState().compliance;

                // Add the newly created compliance standard using compliance_id
                const updatedComplianceStandards = [
                    ...complianceStandards,
                    { compliance_id: data.compliance_id, name: "New Compliance Standard", color: "#3b3b3b" }
                ];

                dispatch({
                    type: "COMPLIANCE_CREATED",
                    complianceStandards: updatedComplianceStandards,
                    newlyCreatedComplianceId: data.compliance_id,
                });
            })
            .catch((error) => {
                console.error("Error creating compliance standard:", error);
            });
    };
};

export const getComplianceProcedures = (compliance_id) => {
    return (dispatch) => {
        axios.post(`${API_URL}/api/compliance/get_procedures`, { compliance_id })
            .then(({ data }) => {
                dispatch({ type: "PROCEDURES", complianceStandards: data });
            });
    };
};

export const editComplianceActionComments = (comment_iid, comments, compliance_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/compliance/edit_action_comments", { comment_iid, comments, compliance_id })
            .then(({ data }) => {
                dispatch({ type: "COMPLIANCE_ACTIONS", actions: data });
            });
    };
};

export const addComplianceActionComments = (action_id, comments, compliance_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/compliance/add_action_comments", { action_id, comments, compliance_id })
            .then(({ data }) => {
                dispatch({ type: "COMPLIANCE_ACTIONS", actions: data });
            });
    };
};


export const getComplianceActions = (compliance_id) => {
    const scopeKey = `comp:${compliance_id ?? 0}`;
    return (dispatch) => {
        dispatch({ type: "COMPLIANCE_ACTIONS_REQUEST", compliance_id });
        axios.get(API_URL + "/api/compliance/get_compliance_actions/" + compliance_id)
            .then(({ data }) => {
                dispatch({ type: "COMPLIANCE_ACTIONS", actions: data, scopeKey });
            });
    };
};

export const getComplianceActionsData = (compliance_id) => {
  const scopeKey = `comp:${compliance_id ?? 0}`;
  return (dispatch) => {
    dispatch({ type: "ACTIONS_DATA_COMP_REQUEST", compliance_id });
    return axios
      .get(
        API_URL +
          "/api/compliance/get_compliance_actions_data/" +
          compliance_id
      )
      .then(({ data }) => {
        dispatch({ type: "ACTIONS_DATA_COMP", actions: data, scopeKey });
        return data;
      })
      .catch((err) => {
        dispatch({ type: "ACTIONS_DATA_COMP_FETCH_FAILED" });
        console.error("Error fetching compliance actions data:", err);
        throw err;
      });
  };
};


export const getComplianceFindings = (compliance_id) => {
  const scopeKey = `comp:${compliance_id ?? 0}`;
  return (dispatch) => {
    dispatch({ type: "COMPLIANCE_FINDINGS_REQUEST", compliance_id });
    return axios
      .get(
        API_URL +
          "/api/compliance/get_compliance_control_findings/" +
          compliance_id
      )
      .then(({ data }) => {
        dispatch({ type: "COMPLIANCE_FINDINGS_DATA", findings: data, scopeKey });
        return data;
      })
      .catch((err) => {
        dispatch({ type: "COMPLIANCE_FINDINGS_FETCH_FAILED" });
        console.error("Error fetching compliance findings:", err);
        throw err;
      });
  };
};
